import React, { FC } from "react";
import rightImgDemo from "images/BecomeAnAuthorImg.png";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import Image from "componentsTemplate/Image";
import Logo from "componentsTemplate/Logo/Logo";
import { Link } from "react-router-dom";

export interface SectionBecomeAnAuthorProps {
  className?: string;
  rightImg?: string;
}

const SectionBecomeAnAuthor: FC<SectionBecomeAnAuthorProps> = ({
  className = "",
  rightImg = rightImgDemo,
}) => {
  return (
    <div
      className={`nc-SectionBecomeAnAuthor relative flex flex-col lg:flex-row items-center  ${className}`}
    >
      <div className="flex-shrink-0 mb-14 lg:mb-0 lg:mr-10 lg:w-2/5">
        {/* <span className="text-xs uppercase tracking-wider font-medium text-neutral-400"> */}
          {/* supper change your planning powers */}
          <Logo />
        {/* </span> */}
        <h2 className="font-semibold text-3xl sm:text-4xl mt-3">
          Quero ser uma Radar
        </h2>
        <span className="block mt-8 text-neutral-500 dark:text-neutral-400">
          Faça parte da maior e mais influente rede de conexões de mulheres no Brasil.
        </span>
        <Link to={'/cadastro'}>
          <ButtonPrimary className="mt-8">Quero entrar para a Radar</ButtonPrimary>
        </Link>
      </div>
      <div className="flex-grow">
        <Image
        className="rounded-2xl"
          alt="hero"
          sizes="(max-width: 768px) 100vw, 50vw"
          src={rightImg}
        />
      </div>
    </div>
  );
};

export default SectionBecomeAnAuthor;
